export default {
  add_client: 'Добавить клиента',
  name: 'Название',
  email: 'Эл. почта',
  phone: 'Номер телефона',
  contact_person: 'Контактное лицо',
  client_description: 'Описание клиента',
  checkout: 'Создать',
  add: 'Добавить',
  cancel: 'Отменить',
  save: 'Сохранить',
  copy: 'Копировать',
  restore: 'Восстановить',
  disclaim: 'Отклонить',
  accept: 'Принять',
  resolve: 'Завершить',
  edit: 'Редактировать',
  print: 'Печать',
  unpause: 'Снять с паузы',
  pause: 'На паузу',
  close: 'Завершить',
  company_name: 'Название компании',
  actions: 'Действия',
  description: 'Описание',
  infocarta: 'Инфокарта',
  clients: 'Клиенты',
  tasks: 'Задачи',
  create_task: 'Создать задачу',
  number: '№',
  message: '@',
  task_name: 'Название',
  hot: 'Срочная',
  task_name2: 'Название задачи',
  client: 'Клиент',
  client_details: 'Детали клиента',
  manager: 'Менеджер',
  designer: 'Дизайнер',
  printer: 'Печатник',
  after_printer: 'Послепечатник',
  master: 'Мастер',
  start_date: 'Дата создания',
  deadline_date: 'Дата сдачи',
  return_back: 'Вернуться',
  price: 'Цена',
  total_cost: 'Итоговая цена',
  clinet: '',
  tel: 'тел.',
  time: 'Время',
  task_description: 'Задача',
  at: 'в',
  paid: 'Оплачен',
  design: 'Дизайн',
  printing: 'Печать',
  after_printing: 'Послепечать',
  add_comment: 'Добавить комментарий',
  task_creation: 'Создание задачи',
  enter_title_task: 'Введите название задачи',
  employment_date: 'Дата поступления',
  test_string: 'Тестовая строка',
  is_paid: 'Оплачено',
  create_date: 'Создано',
  getting_date: 'Поступило',
  return_date: 'Отдать',
  urgently: 'Срочно',
  overdue: 'Просрочено'
}
